import {Plugins, withSystem, EnvTypes} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {
  toBooleanTag,
  TPredicate,
} from '@packages/systems/plugins-utils/Boolean';
import {TTypeConstructor} from '@packages/systems/wfdl-ast';

const VideoType = TTypeConstructor(
  qualify(Plugins.name('Embed'), typeName('Video'))
);

export const getVideoUrl = (video: unknown): string => {
  if (
    !video ||
    typeof video !== 'object' ||
    !('embed' in video) ||
    typeof video.embed !== 'object' ||
    !video.embed ||
    !('url' in video.embed)
  ) {
    return '';
  }
  const url = video.embed.url;
  if (!url || typeof url !== 'string' || url === '') {
    return '';
  }
  return url;
};

const isVideoSet = (video: unknown): boolean => {
  return getVideoUrl(video) !== '';
};

export const videoIsSet: EnvTypes.UnsafeTypedValue = {
  envType: {
    dataType: withSystem({label: 'is set'}, TPredicate(VideoType)),
    exported: 'visible',
  },
  value: (video: unknown) => {
    return toBooleanTag(isVideoSet(video));
  },
};

export const videoIsNotSet: EnvTypes.UnsafeTypedValue = {
  envType: {
    dataType: withSystem({label: 'is not set'}, TPredicate(VideoType)),
    exported: 'visible',
  },
  value: (video: unknown) => {
    return toBooleanTag(!isVideoSet(video));
  },
};
